import { create } from "zustand";
import { persist, createJSONStorage } from 'zustand/middleware';


type RimsStoreType = {
	projection: string;
	setProjection: (projection: string) => void;

	clickedPolygonIDs: string[];
	setClickedPolygonIDs: (clickedPolygonIDs: string[]) => void;

	thousandsSeparator: string;
	setThousandsSeparator: (separator: string) => void;

	decimalSeparator: string;
	setDecimalSeparator: (separator: string) => void;

	currencySymbol: string;
	setCurrencySymbol: (symbol: string) => void;
};


const useStore = create(
	persist<RimsStoreType>(
		(set) => ({
			projection: 'EPSG:3067',
			setProjection: (projection) => set({ projection: projection }),

			clickedPolygonIDs: [],
			setClickedPolygonIDs: (clickedPolygonId) => set({ clickedPolygonIDs: clickedPolygonId }),

			thousandsSeparator: ',',
			setThousandsSeparator: (separator) => set({ thousandsSeparator: separator }),

			decimalSeparator: '.',
			setDecimalSeparator: (separator) => set({ decimalSeparator: separator }),

			currencySymbol: 'EUR',
			setCurrencySymbol: (symbol) => set({ currencySymbol: symbol }),
		}),
		{
			name: 'rims-storage', // name of the item in the storage (must be unique)
			version: 4, //version of the data, increment to invalidate old data
			storage: createJSONStorage(() => localStorage) // (optional) by default, 'localStorage' is used
		}
	)
);

export default useStore;